// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent, EditableComponentProps } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

// Use named rather than default exports.
import { LoyaltyCompassProps } from './LoyaltyCompass.types';
const LoyaltyCompass = dynamic(() => import('./LoyaltyCompass').then(mod => mod.LoyaltyCompass));

export const LoyaltyCompassConfig = {
  emptyLabel: 'Loyalty Compass',
  isEmpty: () => true,
  resourceType: 'mi-aem-account/components/content/loyaltycompass',
};

type editableCompAccountProps = EditableComponentProps & LoyaltyCompassProps;

export const LoyaltyCompassEditable = (props: editableCompAccountProps) => (
  // editable component export
  <EditableComponent config={LoyaltyCompassConfig} {...props}>
    <LoyaltyCompass {...props} />
  </EditableComponent>
);
